<template>
    <div class="unionList" @scroll="handleScroll">
        <div>
            <div class="mechanism">已申请机构</div>
            <div class="mechanism" @click="eject()" style="float: right;margin-right: 0.3rem;color: red">公益法律服务联盟</div>
        </div>
        <div style="border-bottom: 0.01rem solid #dddddd;">
            <img class="search" src="/img/lawUnion/search.png">
            <input v-model="key" v-on:keyup="orgList(1)" class="searchMechanism" type="text" placeholder="搜索已申请机构" />
        </div>
        <div class="center" >
            <div class="inline-block" style="box-shadow: rgb(136, 136, 136) 0px 0.04rem 0.12rem -0.05rem;margin-top: 0.3rem;" v-for="(value,index) in listData">
                <div class="room inline-block">
                    <img class="icon-huabanfuben" src="/img/lawUnion/houtai-icon_huabanfuben.png">
                </div>
                <div class="rightName inline-block">
                    <p>{{value.orgname}}</p>
                </div>
            </div>
            <div style="padding: 0.6rem;"></div>
        </div>
        <!--申请-->
        <div style="position: fixed;bottom: -1px;">
            <router-link to="unionForm" style="color: #999999;"><div class="apply">申 请</div></router-link>
        </div>
        <!--弹出-->
        <div class="el-alert1" v-if="display">
            <div class="whiteboard">
                <div class="title">公益法律服务联盟</div>
                <div class="word">
                    <p><span style="font-weight: bold;">1、发起者： </span><p style="font-size: 0.3rem;">公益法律服务联盟由微律名片、律所、律师等成员共同发起，是首个法律行业公益组织。</p></p>
                    <p><span style="font-weight: bold;">2、联盟宗旨： </span><p style="font-size: 0.3rem;">整合法律界资源，针对需要帮助的人们（农民工、残疾人、老年人、妇女家庭、未成年人）提供法律咨询法律援助服务。</p></p>
                    <p><span style="font-weight: bold;">3、联盟成员获得： </span><p style="font-size: 0.3rem;">“微律名片”的公益案件专区联盟成员展示。</p></p>
                    <p class="center" style="font-size: 0.3rem;">“微律名片”的案源中心优先配发权。</p>
                    <img style="width: 100%;height: 100%;margin-top: 0.3rem;" src="/img/lawUnion/w.jpg">
                </div>
                <div class="close" @click="eject()">关闭</div>
            </div>
        </div>
        <!--<div class="el-alert1" v-if="display">-->
            <!--<div class="whiteboard">-->
                <!--<div class="title">专属福利-长按保存图片</div>-->
                <!--<div class="word">-->
                    <!--<Carousel dots="none" arrow="always">-->
                        <!--<Carousel-item>-->
                            <!--<img style="width: 100%;height: 5rem;" src="/img/lawUnion/w.jpg">-->
                            <!--<p class="center">律师的社交圈，每日更新大量案源</p>-->
                        <!--</Carousel-item>-->
                        <!--<Carousel-item>-->
                            <!--<img style="width: 100%;height: 5rem;" src="/img/lawUnion/qa.jpg">-->
                            <!--<p class="center">智能咨询系统，律师好助手</p>-->
                        <!--</Carousel-item>-->
                    <!--</Carousel>-->
                <!--</div>-->
                <!--<div class="close" @click="eject()">关闭</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    export default {
        name: "unionList",
        data () {
            return {
                page: '1',
                pageSize: '15',
                key : '',
                listData : [],
                firstname : '',
                display : false
            }
        },
        methods :{
            orgList:function(type){
                var _this = this
                if(type == 1){
                    _this.listData = []
                    _this.page = 1
                }
                _this.send({
                    server : 'ai',
                    url : '/orgList',
                    data: {page:_this.page,pageSize:_this.pageSize,key:_this.key},
                    success: function (res) {
                        var newdata = _this.listData
                        for (var i = 0; i < res.data.length; i++) {
                            new Array(newdata.push(res.data[i]))
                        }
                        _this.listData = newdata
                    }
                })
            },
            handleScroll(event) {
                var _this = this
                if(event.target.scrollHeight-event.target.scrollTop-event.target.clientHeight == 0){
                    _this.page++
                    _this.orgList()
                }
            },
            eject:function(){
                var _this = this
                _this.display = !_this.display
            },
            setActiveItem(index){
                this.$refs.carousel.setActiveItem(index)
            }
        },
        mounted () {
            var _this = this
            this.orgList()
            window.addEventListener('scroll', this.handleScroll, true)
            console.log(sessionStorage.type)
            if(sessionStorage.type == 1){
                _this.display = true
                sessionStorage.type = 0
            }
        },


    }
</script>

<style scoped>
.mechanism{color: #333333;font-size: 0.34rem;display: inline-block;text-align: left;margin-left: 0.3rem;margin-top: 0.2rem;}
    .search{width: 0.28rem;height: 0.28rem;vertical-align: top;margin-top: 0.35rem;margin-left: 0.3rem;}
    .searchMechanism{color: #c7cbd5;font-size: 0.26rem;padding: 0.3rem 0;margin-left: 0.2rem;}
    .icon-huabanfuben{width: 0.28rem;height: 0.28rem;}
    .room{width: 0.88rem;height: 0.88rem;background-color: #f5f6fa;line-height: 1.02rem;text-align: center;}
    .rightName{width: 6.02rem;height: 0.88rem;background-color: #fff;vertical-align: top;color: #454545;font-size: 0.26rem;line-height: 0.88rem;text-align: left;margin-left: 0.19rem;}
.apply{width: 7.5rem;height: 0.96rem;background-color: #4e79f4;color: #ffffff;text-align: center;font-size: 0.3rem;line-height: 0.96rem;}


.el-alert1{background-color: rgba(0,0,0,0.3);position: fixed;width: 100%;height: 100%;top: 0;display: flex;}
/*.whiteboard{width: 5.7rem;background-color: #fff;position: absolute;left: 50%;margin-left: -2.85rem;align-self: center;    height: 8rem;}*/
.whiteboard{width: 5.7rem;background-color: #fff;position: absolute;left: 50%;margin-left: -2.85rem;align-self: center;}
.title{font-size: 0.3rem;color: #454545;line-height: 1rem;border-bottom: 0.01rem solid #dddddd;text-align: center}
/*.word{font-size: 0.26rem;color: #454545;padding: 0.39rem 0.39rem 0.51rem;}*/
.word{font-size: 0.26rem;color: #454545;padding: 0.3rem 0.3rem 0.51rem}
.close{width: 1.77rem;height: 0.6rem;background-color: #4e79f4;border-radius: 0.3rem;color: #FFF;text-align: center;line-height: 0.6rem;position: absolute;bottom: -0.3rem;left: 50%;margin-left: -0.885rem;}

.unionList >>> .ivu-carousel-arrow.right {text-align: center;}
.unionList >>> .ivu-carousel-arrow.left {text-align: center;}
</style>
